import {
  getMostCurrentDataDashboardStat,
  parseFinancial,
} from 'utils/Financials';

import {DashboardStatData} from 'components/v2/app/dashboard/models';

export const NumberStat = ({
  title,
  description,
  diff,
}: {
  title: string;
  description: string;
  diff: number;
}) => {
  return (
    <>
      <div className={'flex flex-col gap-2 justify-end max-md:h-fit'}>
        <div className={'flex flex-col gap-1'}>
          <span className={'text-[#2B53E1] text-[14px] font-bold'}>
            {diff >= 0 ? '+' : '-'}${parseFinancial(diff)}
          </span>
          <h2 className={'text-[36px] font-bold'}>{title}</h2>
          <span className={'text-[12px] text-[#7D7D7D] font-bold uppercase'}>
            {description}
          </span>
        </div>
      </div>
    </>
  );
};

export const DashboardOverviewStats = ({
  stats,
  period,
}: {
  stats: DashboardStatData;
  period: string;
}) => {
  const currentData = stats[period as keyof typeof stats];
  const currentMostRecentData = getMostCurrentDataDashboardStat(currentData);

  return (
    <>
      <div className="flex gap-10 justify-between h-full max-md:grid max-md:grid-cols-2 max-md:my-auto max-md:gap-5">
        <NumberStat
          diff={currentMostRecentData?.profit_diff || 0}
          title={`$${parseFinancial(currentMostRecentData?.profit || 0)}`}
          description={'Total profit'}
        />
        <div
          className={
            'max-md:hidden h-auto w-[0.5px] bg-[#DADADA] dark:bg-[#313131]'
          }
        />
        <NumberStat
          diff={currentMostRecentData?.transactions_diff || 0}
          title={`${currentMostRecentData?.transactions || 0}`}
          description={'Transactions'}
        />
        <div
          className={
            'max-md:hidden h-auto w-[0.5px] bg-[#DADADA] dark:bg-[#313131]'
          }
        />
        <NumberStat
          diff={currentMostRecentData?.revenue_diff || 0}
          title={`$${parseFinancial(currentMostRecentData?.revenue || 0)}`}
          description={'Total revenue'}
        />
      </div>
    </>
  );
};

export const PaymentsOverviewStats = ({
  stats,
  period,
}: {
  stats: DashboardStatData;
  period: string;
}) => {
  const currentData = stats[period as keyof typeof stats];
  const currentMostRecentData = getMostCurrentDataDashboardStat(currentData);

  return (
    <>
      <div className="flex gap-10 justify-between h-full max-md:grid max-md:grid-cols-2 max-md:my-auto max-md:gap-5">
        <NumberStat
          diff={currentMostRecentData?.transactions_diff || 0}
          title={`$${parseFinancial(currentMostRecentData?.transactions || 0)}`}
          description={'Transactions'}
        />
        <div
          className={
            'max-md:hidden h-auto w-[0.5px] bg-[#DADADA] dark:bg-[#313131]'
          }
        />
        <NumberStat
          diff={currentMostRecentData?.profit_diff || 0}
          title={`${currentMostRecentData?.profit || 0}`}
          description={'Value'}
        />
        <div
          className={
            'max-md:hidden h-auto w-[0.5px] bg-[#DADADA] dark:bg-[#313131]'
          }
        />
        <NumberStat
          diff={currentMostRecentData?.revenue_diff || 0}
          title={`$${parseFinancial(currentMostRecentData?.revenue || 0)}`}
          description={'Total revenue'}
        />
      </div>
    </>
  );
};
